export const ROUTE_SEGMENT = {
  quotes: "quotes",
  offers: "offers",
  orders: "orders",
  billing: "billing",
  support: "support",
  settings: "settings",
  deliveryInformation: "delivery-information",
  account: "account",
  notifications: "notifications",
  store: "store",
  myOrders: "my-orders",
  offersPending: "offers-pending",
  orderInProgress: "order-in-progress",
  deliveryInProgress: "delivery-in-progress",
  ordersPlaced: "orders-placed",
  ordersInDelivery: "orders-in-delivery",
  ordersCompleted: "completed",
  ordersCancelled: "cancelled",
  cart: "cart",
  checkout: "checkout",
};

export const ROUTES_MAP = {
  home: "/",
  orders: "/orders",
  purchaseOrders: "/purchase-orders",
  stockList: "/stock-list",
  handovers: "/handovers",
  salesOpportunities: "/sales-opportunities",
  invoices: "/invoices",
  pqIngestionFiles: "/pq-ingestion-files",

  authLogin: "/auth/login",
  authRegister: "/auth/register",
  authChoose: "/auth/choose",
  authRegisterSuccess: "/auth/register-success",
  authMagicLogin: "/auth/magic-login",
  authForgotPassword: "/auth/forgot-password",
  authSuppliers: "/auth/suppliers",
};

export type RoutesMapValue<T> = T[keyof T];

export const EXTERNAL_ROUTES_MAP_ENUM = {
  generalTermsAndConditions: "https://andercore.com/en/terms/",
  monduTermsAndConditions: "https://www.mondu.ai/m1-payment-postponement-agreement/",
  monduPrivacyPolicy: "https://www.mondu.ai/gdpr-notification-for-buyers/",
  andercore: "https://andercore.com",
};
